<template>
    <div class="bets-element" @click="openBetDetail">
        <div class="element-player-mobile">
            <div class="element-game">
            <IconCrash v-if="bet.method === 'crash'" />
            <IconRoll v-else-if="bet.method === 'roll'" />
            <IconBlackjack v-else-if="bet.method === 'blackjack'" />
            <IconDuels v-else-if="bet.method === 'duels'" />
            <IconMines v-else-if="bet.method === 'mines'" />
            <IconTowers v-else-if="bet.method === 'towers'" />
            <IconUnbox v-else-if="bet.method === 'unbox'" />
            <IconBattles v-else-if="bet.method === 'battles'" />
            <!-- <IconSlots v-else-if="bet.method === 'slots'" /> -->
            <IconDiamond v-else-if="bet.method === 'slots'" />
            <span v-bind:class="{
                'gradient-yellow': bet.method === 'crash',
                'gradient-green': bet.method === 'roll',
                'gradient-blue-dark': bet.method === 'blackjack',
                'gradient-red': bet.method === 'duels',
                'gradient-purple': bet.method === 'mines',
                'gradient-blue': bet.method === 'towers',
                'gradient-pink': bet.method === 'unbox',
                'gradient-orange': bet.method === 'battles',
                'gradient-gold': bet.method === 'slots'
            }">{{betsGetGameName}}</span>
        </div>
        <div class="element-user" v-bind:class="[
            bet.user === null ? 
                'user-hidden' :
                ['user-' + betsGetRank(bet.user), 'user-' + betsGetLevelColor(bet.user)],
            bet.bot === true ? 'user-bot' : ''
        ]">
            <div class="user-avatar">
                <AvatarImage v-bind:image="bet.user === null ? null : bet.user.avatar" />
            </div>
            <div v-if="bet.user !== null" v-html="bet.user.username" class="user-username"></div>
            <div v-else>Anonymous</div>
        </div>
        </div>
        <div class="element-time">
            <span>{{ betsGetDate[0] }},</span>{{ betsGetDate[1] }}
        </div>
        <div class="element-wager">
            <IconCoin />
            <div class="wager-value">
                <span>{{betsFormatValue(betsGetAmount).split('.')[0]}}</span>.{{betsFormatValue(betsGetAmount).split('.')[1]}}
            </div>
        </div>
        <div class="element-multiplier">
            <span v-bind:class="{ 'gradient-green': betsGetMultiplier > 0 }">{{parseFloat(betsGetMultiplier).toFixed(2)}}x</span>
        </div>
        <div class="element-payout" v-bind:class="{ 'payout-positive': (bet.payout / betsGetAmount) > 0 }">
            <IconCoin />
            <div class="payout-value">
                <span>{{betsFormatValue(bet.payout).split('.')[0]}}</span>.{{betsFormatValue(bet.payout).split('.')[1]}}
            </div>
        </div>
    </div>
</template>

<script>
    import AvatarImage from '@/components/AvatarImage';
    import IconCrash from '@/components/icons/IconCrash';
    import IconRoll from '@/components/icons/IconRoll';
    import IconBlackjack from '@/components/icons/IconBlackjack';
    import IconDuels from '@/components/icons/IconDuels';
    import IconMines from '@/components/icons/IconMines';
    import IconTowers from '@/components/icons/IconTowers';
    import IconUnbox from '@/components/icons/IconUnbox';
    import IconBattles from '@/components/icons/IconBattles';
    // import IconSlots from '@/components/icons/IconSlots';
    import IconDiamond from '@/components/icons/IconDiamond';
    import IconCoin from '@/components/icons/IconCoin';
    import { mapActions } from 'vuex';

    export default {
        name: 'BetsElement',
        components: {
            AvatarImage,
            IconCrash,
            IconRoll,
            IconBlackjack,
            IconDuels,
            IconMines,
            IconTowers,
            IconUnbox,
            IconBattles,
            // IconSlots,
            IconDiamond,
            IconCoin
        },
        props: [
            'bet'
        ],
        methods: {
            ...mapActions(['modalsSetShow', 'modalsSetData']),
            betsFormatValue(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            openBetDetail() {
                this.modalsSetData({ bet: this.bet, gameType: this.bet.method || 'crash' });
                this.modalsSetShow('BetDetail');
            },
            betsGetRank(user) {
                let rank = user.rakeback;

                if(user.rank !== 'user') { rank = user.rank; }

                return rank;
            },
            betsGetLevelColor(user) {
                let color = '';

                if(user.level >= 2 && user.level < 26) { color = 'blue'; }
                else if(user.level >= 26 && user.level < 51) { color = 'green'; }
                else if(user.level >= 51 && user.level < 76) { color = 'orange'; }
                else if(user.level >= 76 && user.level < 100) { color = 'red'; }
                else if(user.level >= 100) { color = 'purple'; }

                return color;
            }
        },
        computed: {
            betsGetMethod() {
                let method = this.bet.method.charAt(0).toUpperCase() + this.bet.method.slice(1);

                if(this.bet.method === 'duels') {
                    method = 'Dice Duels';
                }

                return method;
            },
            betsGetGameName() {
                // For slots, display the actual game name if available
                if(this.bet.method === 'slots' && this.bet.gameName) {
                    return this.bet.gameName;
                }
                
                // Otherwise use the method name
                return this.betsGetMethod;
            },
            betsGetDate() {
                let date = new Date(this.bet.updatedAt).toLocaleString('en-US', { 
                    hour12: true, 
                    year: 'numeric', 
                    month: 'numeric', 
                    day: 'numeric', 
                    hour: '2-digit', 
                    minute:'2-digit' 
                });

                return date.split(',');
            },
            betsGetAmount() {
                let amount = this.bet.amount;

                if(this.bet.method === 'blackjack') {
                    amount = Math.floor(this.bet.amount.main + this.bet.amount.sideLeft + this.bet.amount.sideRight);
                    if(this.bet.actions.includes('split') === true) { amount = Math.floor(amount + this.bet.amount.main); }
                }
                // All games (including duels) store amounts as $1 = 1

                return amount;
            },
            betsGetMultiplier() {
                let multiplier = this.bet.multiplier / 100;

                if(['crash', 'roll'].includes(this.bet.method) === true) { multiplier = this.bet.payout / this.betsGetAmount; }

                return multiplier;
            }
        }
    }
</script>

<style scoped>
    .bets-element {
        width: 100%;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 35px;
        background: var(--bg-table-background);
        border: 1px solid var(--accent-blue-dark);
        transition: background 0.3s ease;
        cursor: pointer;
    }

    .bets-element:hover {
        background: rgba(255, 255, 255, 0.05);
    }

    .bets-element:last-child {
        border-bottom: none;
    }

    .element-player-mobile {
        display: contents;
    }

    .bets-element .element-game {
        width: 20%;
        max-width: 80px;
        display: flex;
        align-items: center;
    }

    .bets-element .element-game svg {
        margin-right: 10px;
        filter: brightness(0) invert(1) !important;
    }

    .bets-element .element-game span {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 180px;
        display: inline-block;
    }

    .bets-element .element-game span.gradient-yellow,
    .bets-element .element-game span.gradient-green,
    .bets-element .element-game span.gradient-blue-dark,
    .bets-element .element-game span.gradient-red,
    .bets-element .element-game span.gradient-purple,
    .bets-element .element-game span.gradient-blue,
    .bets-element .element-game span.gradient-pink,
    .bets-element .element-game span.gradient-orange,
    .bets-element .element-game span.gradient-gold {
        color: #ffffff;
        background: none;
        -webkit-background-clip: unset;
        -webkit-text-fill-color: #ffffff;
        background-clip: unset;
    }

    .bets-element .element-user {
         width: 20%;
         display: flex;
         align-items: center;
         font-size: 14px;
         font-weight: 500;
         color: var(--text-primary);
    }

    .bets-element .element-user.user-hidden {
        font-style: italic;
    }

    .bets-element .user-avatar {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-right: 10px;
        border-radius: 50%;
        background: var(--gradient-yellow);
        overflow: hidden;
        flex-shrink: 0;
    }

    .bets-element .element-user.user-blue .user-avatar {
        border: 1px solid #559ee4;
    }

    .bets-element .element-user.user-green .user-avatar {
        border: 1px solid #b8e92d;
    }

    .bets-element .element-user.user-orange .user-avatar {
        border: 1px solid #fca311;
    }

    .bets-element .element-user.user-red .user-avatar {
        border: 1px solid #ff4e4e;
    }

    .bets-element .element-user.user-purple .user-avatar {
        border: 1px solid #6953f1;
    }

    .bets-element .element-user.user-partner .user-avatar {
        border: 1px solid #eca822;
    }

    .bets-element .element-user.user-mod .user-avatar {
        border: 1px solid #ffb703;
    }

    .bets-element .element-user.user-admin .user-avatar {
        border: 1px solid #00ffc2;
    }

    .bets-element .user-avatar .avatar-image {
        width: 20px;
        height: 20px;
    }

    .bets-element .user-hidden .user-avatar .avatar-image {
        width: 24px;
        height: 24px;
    }

    .bets-element .user-username {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .bets-element .element-user.user-bot .user-avatar {
        border: 1px solid #fbbf24 !important;
        box-shadow: 0 0 8px rgba(251, 191, 36, 0.4);
    }

    .bets-element .element-time {
         width: 20%;
         display: flex;
         align-items: center;
         font-size: 14px;
         font-weight: 400;
         color: var(--text-primary);
    }

    .bets-element .element-time span {
        margin-right: 4px;
    }

    .bets-element .element-wager,
    .bets-element .element-payout {
        width: 15%;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .bets-element .element-payout {
        justify-content: flex-end;
    }

    .bets-element .element-wager svg,
    .bets-element .element-payout svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        filter: drop-shadow(0 2px 4px rgba(251, 191, 36, 0.3));
        transition: all 0.3s ease;
    }

    .bets-element:hover .element-wager svg,
    .bets-element:hover .element-payout svg {
        filter: drop-shadow(0 2px 6px rgba(251, 191, 36, 0.5));
        transform: scale(1.08);
    }

    .bets-element .wager-value,
    .bets-element .payout-value {
        display: flex;
        align-items: baseline;
        font-size: 11px;
        font-weight: 600;
        color: rgba(187, 191, 208, 0.7);
        letter-spacing: 0.3px;
    }

    .bets-element .wager-value span,
    .bets-element .payout-value span {
        font-size: 15px;
        font-weight: 800;
        margin-right: 1px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    .bets-element .wager-value span {
        color: #ffffff;
        background: linear-gradient(180deg, #ffffff 0%, #e5e7eb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .bets-element .payout-value span {
        color: rgba(187, 191, 208, 0.9);
    }

    .bets-element .payout-positive .payout-value span {
        background: linear-gradient(180deg, #10b981 0%, #059669 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 900;
        text-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }

    .bets-element .element-multiplier {
        width: 10%;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: var(--accent-green);
    }

    @media only screen and (max-width: 950px) {
        /* Mobile: compact 3-column layout (Player | Payout | Multi) like reference */
        .bets-element {
            height: auto;
            min-height: 52px;
            display: grid;
            grid-template-columns: 1fr 90px 60px;
            grid-template-rows: 1fr;
            gap: 0;
            padding: 0 16px;
            align-items: center;
            background: var(--bg-secondary);
            border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .bets-element:nth-child(even) {
            background: rgba(255, 255, 255, 0.02);
        }

        .element-player-mobile {
            display: flex;
            align-items: center;
            gap: 10px;
            grid-column: 1;
            grid-row: 1;
            min-width: 0;
        }

        /* Player: game icon + avatar + username */
        .bets-element .element-game {
            width: auto;
            flex-shrink: 0;
            justify-content: flex-start;
        }

        .bets-element .element-game svg {
            width: 18px;
            height: 18px;
            margin-right: 4px;
            flex-shrink: 0;
        }

        .bets-element .element-game span {
            font-size: 11px;
            max-width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .bets-element .element-user {
            width: auto;
            flex: 1;
            min-width: 0;
            justify-content: flex-start;
        }

        .bets-element .user-avatar {
            width: 22px;
            height: 22px;
            margin-right: 8px;
            flex-shrink: 0;
        }

        .bets-element .user-avatar .avatar-image {
            width: 18px;
            height: 18px;
        }

        .bets-element .element-user,
        .bets-element .element-user .user-username {
            font-size: 13px;
        }

        .bets-element .user-username {
            max-width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        /* Hide time, wager on mobile */
        .bets-element .element-time,
        .bets-element .element-wager {
            display: none;
        }

        /* Payout: center column */
        .bets-element .element-payout {
            grid-column: 2;
            grid-row: 1;
            width: 100%;
            justify-content: center;
            gap: 4px;
        }

        .bets-element .element-payout svg {
            width: 14px;
            height: 14px;
        }

        .bets-element .payout-value,
        .bets-element .payout-value span {
            font-size: 13px;
        }

        .bets-element .payout-value {
            color: rgba(255, 255, 255, 0.6);
        }

        .bets-element .payout-positive .payout-value span {
            color: var(--accent-green);
        }

        /* Multiplier: right column */
        .bets-element .element-multiplier {
            grid-column: 3;
            grid-row: 1;
            width: 100%;
            justify-content: flex-end;
            font-size: 13px;
        }

        .bets-element .element-multiplier::before,
        .bets-element .element-multiplier::after {
            display: none;
        }

        .bets-element .element-multiplier span.gradient-green {
            color: var(--accent-green);
        }
    }

    @media only screen and (max-width: 475px) {
        .bets-element .user-username {
            max-width: 85px;
        }

        .bets-element .element-time span {
            display: none;
        }
    }
</style>
